window.TV2 = window.TV2 || {};

window.TV2.initSubNavbar = (id) => {
  const subnavbar = document.querySelector(`#${id}`);
  const observer = new IntersectionObserver(
    ([e]) => e.target.classList.toggle('subnavbar--pinned', e.intersectionRatio < 1),
    { threshold: [1] },
  );
  observer.observe(subnavbar);

  const activeMenu = subnavbar.querySelector('.subnavbar__link--active');
  if (activeMenu && 'scrollIntoViewIfNeeded' in activeMenu) {
    activeMenu.scrollIntoViewIfNeeded();
  }
};
